import { CoinSection } from './CoinSection'
import { withCoinSection } from './withCoinSection'

const ConnectedCoinSection = withCoinSection(CoinSection)

export { ConnectedCoinSection as CoinSection }
